import React, { lazy, Suspense } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import HeroSection from '../components/HeroSection';
import SEO from '../components/SEO';
import { useLanguage } from '../context/LanguageContext';
import { ROUTE_MAP } from '../data/routes';

const NewsSection = lazy(() => import('../components/NewsSection'));
const CTASection = lazy(() => import('../components/CTASection'));
const EnergyTransitionSection = lazy(() => import('../components/EnergyTransitionSection'));
const ServicesSection = lazy(() => import('../components/ServicesSection'));
const ClientsSection = lazy(() => import('../components/ClientsSection'));

const HomePage = () => {
  const { locale, t } = useLanguage();

  const seo = {
    title: t('Ana Sayfa', 'Home', 'Ana Səhifə'),
    description: t(
      'Demart Mühendislik ile vana kilitleri, taşınabilir aktüatörler ve vana bakım çözümleriyle operasyon güvenliğinizi güçlendirin.',
      'Strengthen operational safety with Demart valve interlocks, portable actuators and valve maintenance solutions.',
      'Demart vana kilidləri, daşınan aktuatorlar və vana baxım həlləri ilə əməliyyat təhlükəsizliyini gücləndirin.'
    ),
    urlPath: ROUTE_MAP[locale].home,
    imagePath: '/images/brand/logo.webp',
    alternates: {
      tr: ROUTE_MAP.tr.home,
      en: ROUTE_MAP.en.home,
      az: ROUTE_MAP.az.home,
      'x-default': ROUTE_MAP.tr.home
    }
  };

  return (
    <div className="min-h-screen flex flex-col bg-white dark:bg-gray-900">
      <SEO {...seo} lang={locale} />
      <Header />
      <main className="flex-grow pt-[104px]">
        <HeroSection />
        <Suspense fallback={<div className="h-12" aria-hidden="true" />}>
          <div className="cv-auto">
            <NewsSection />
          </div>
          <div className="cv-auto">
            <CTASection />
          </div>
          <div className="cv-auto">
            <EnergyTransitionSection />
          </div>
          <div className="cv-auto">
            <ServicesSection />
          </div>
          <div className="cv-auto">
            <ClientsSection />
          </div>
        </Suspense>
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
